module.exports = {"title":"고고밴 이용약관 (고객 버전)","tc_consumer_headline":"이용약관 (고객 버전)","meta":{"keywords":"이용약관, 고고밴","description":"고고밴 이용약관 (고객 버전)"}}


//////////////////
// WEBPACK FOOTER
// ./src/assets/json/kr/setting/tc_consumer/locale.json
// module id = 689
// module chunks = 0 1 2 3 4 5